// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import { watch, watchAnimation } from "~/state/util";

Mapy.LayerTraffic = function(id, options = {}) {
	this._geometries = [];
	this._canvas = null;
	this._ctx = null;
	this._animationId = -1;
	this._typeIds = options.typeIds || [];

	SMap.Layer.call(this, id || "layer-traffic");
	const wt = watch(store.getState, "map", watchAnimation);

	this._storeAnimationUnsubscribe = store.subscribe(wt(newMap => {
		if (!newMap.animating) {
			this.clear();
		}
	}));
}

Mapy.LayerTraffic.prototype = Object.create(Object.assign({}, SMap.Layer.prototype));

Mapy.LayerTraffic.prototype.$destructor = function() {
	SMap.Layer.prototype.$destructor.call(this);
	this._storeAnimationUnsubscribe?.();
	this._storeAnimationUnsubscribe = null;
}

Mapy.LayerTraffic.prototype._build = function() {
	this._dom.container[SMap.LAYER_TILE] = Mapy.Util.node("div");
	this._canvas = document.createElement("canvas");
	this._canvas.style.position = "absolute";
	this._ctx = this._canvas.getContext("2d");

	this._dom.container[SMap.LAYER_TILE].appendChild(this._canvas);
};

Mapy.LayerTraffic.prototype.clear = function() {
	let size = null;
	let offset = null;
	let position = null;

	if (this._canvas) {
		let map = this.getMap();
		if (map) {
			size = map.getSize();
			offset = map.getOffset();
			position = size.clone().scale(-0.5).minus(offset);

			this._canvas.width = size.x;
			this._canvas.height = size.y;
			this._canvas.style.left = position.x + "px";
			this._canvas.style.top = position.y + "px";
		}
	}

	return {
		size,
		offset,
		position
	}
}

Mapy.LayerTraffic.prototype.removeAll = function() {
	this._geometries.length = 0;
	if (this._geoms) {
		this._geoms.length = 0;
	}

	this.clear();
}

Mapy.LayerTraffic.prototype.fillFromData = function(data) {
	if (!this._active) return;


	for (let i = 0; i < data.length; i++) {
		let lookup = data[i];

		const pois = lookup?.poi?.filter(i => this._typeIds.indexOf(i.typeId) !== -1) || [];
		let trafficGemometry = new Mapy.TrafficGeometry(pois, this.getMap().getZoom(), this.getMap().getCenter().toWGS84()[1]);

		this._geometries = trafficGemometry.geometries;

		this._draw();
	}
};

Mapy.LayerTraffic.prototype.getCanvas = function() {
	return this._canvas;
}

Mapy.LayerTraffic.prototype.redraw = function(full) {
	if (!this._active) return;

	this._draw();
}

/**
 * Nastaveni kresleni.
 *
 * @return {Object} vraci rozmery mapy a pozici
 */
Mapy.LayerTraffic.prototype._drawSetup = function(map) {
	let size = map.getSize();
	let offset = map.getOffset();
	let position = size.clone().scale(-0.5).minus(offset);

	// nastaveni contextu
	this._ctx.lineJoin = "round";

	return {
		size, position
	};
};

/**
 * Hlavni vykreslovaci smycka.
 */
Mapy.LayerTraffic.prototype._draw = function() {
	if (this._animationId != -1) {
		window.cancelAnimationFrame(this._animationId);
	}

	this._animationId = requestAnimationFrame(() => {
		this.clear();

		// predpocitame si pixely
		let map = this.getMap();

		if (!map) return;

		// nastaveni canvasu pro kresleni
		let setupData = this._drawSetup(map);
		let centerPixel = new SMap.Pixel(Math.round(setupData.size.x / 2), Math.round(setupData.size.y / 2));

		// spocitame pixely
		let geometries = [];
		let points = [];

		for (let g = 0; g < this._geometries.length; g++) {
			let geometry = this._geometries[g]
			if (geometry.coords.length == 2 && typeof(geometry.coords[1]) == "number") { // pointy
				points.push({
					pixels: [geometry.coords[0].toPixel().plus(centerPixel)],
					radius: geometry.coords[1],
					style: this._setStyle(geometry.style),
					geom: geometry
				})
			}
			else {
				let pixels = [];
				for (let i = 0; i < geometry.coords.length; i++) {
					let p = geometry.coords[i].toPixel();
					pixels.push(p.plus(centerPixel));
				}
				let len = pixels.length;

				// optimalizace pro kresleni
				let leftInd = 0;
				let leftSet = false;
				let rightInd = 0;
				let rightSet = false;

				for (let i = 0, max = len - 1, j = max; i <= max; i++, j--) {
					if (!leftSet && this._viewportTest(setupData.size, pixels[i])) {
						// vezmeme predchozi bod
						leftInd = Math.max(i - 1, 0);
						leftSet = true;
					}

					if (!rightSet && this._viewportTest(setupData.size, pixels[j])) {
						// vezmeme dalsi bod
						rightInd = Math.min(j + 1, len - 1);
						rightSet = true;
					}

					if (leftSet && rightSet) break;
				}

				// orezeme zleva a zprava, aby tam nebyly prazdne body - chceme pouze 2+ bodu
				if (rightInd + 1 - leftInd > 1) {
					geometries.push({
						pixels: pixels.slice(leftInd, rightInd + 1),
						style: this._setStyle(geometry.style),
						geom: geometry
					});
				}
			}
		};

		for (let i = 0; i < geometries.length; i++) {
			let geometry = geometries[i];
			// pro pozadi - musi mit sirku, normalni cara musi mit sirku a nesmi byt pruhledna!
			if (geometry.style.outlineWidth > 0 && geometry.style.color != "rgba(0, 0, 0, 0)") {
				let ctxStyle = this._setStyleToContext(this._ctx, geometry.pixels, geometry.style, true);
				this._drawPixels(this._ctx, geometry.pixels, ctxStyle, geometry.geom, true);
			}
		};

		// vykreslime cary
		for (let i = 0; i < geometries.length; i++) {
			let geometry = geometries[i];
			if (geometry.style.width > 0) {
				let ctxStyle = this._setStyleToContext(this._ctx, geometry.pixels, geometry.style);
				this._drawPixels(this._ctx, geometry.pixels, ctxStyle, geometry.geom);
			}
		};

		// vykreslime pointy
		for (let  i = 0; i < points.length; i++) {
			let point = points[i];

			if (point.style.width > 0) {
				let style = {
					strokeStyle: point.style.outlineColor,
					globalAlpha: point.style.opacity,
					lineWidth: point.style.outlineWidth,
					fillStyle: point.style.color
				}

				this._ctx.strokeStyle = style.strokeStyle;
				this._ctx.globalAlpha = style.globalAlpha;
				this._ctx.lineWidth = style.lineWidth;
				this._ctx.fillStyle = style.fillStyle;

				this._drawPoint(this._ctx, point, style);
			}
		}

		this._animationId = -1;
	});

	this._animationId = -1;
}

/**
 * Nastaveni stylu pro vykresleni cary.
 *
 * @return {Object}
 */
Mapy.LayerTraffic.prototype._setStyle = function(geomStyle) {
	let style = Object.assign({
		width: 1,
		outlineWidth: 0
	}, geomStyle);

	if ("width" in style) {
		style.width = parseFloat(style.width);
	}

	if ("outlineWidth" in style) {
		style.outlineWidth = parseFloat(style.outlineWidth);
	}

	if ("opacity" in style) {
		style.opacity = parseFloat(style.opacity);
	}

	if ("outlineOpacity" in style) {
		style.outlineOpacity = parseFloat(style.outlineOpacity);
	}

	return style;
}

/**
 * Test na viewport
 *
 * @param {Object} size Rozmery mapy
 * @param {Object} pixel Testovany pixel
 * @return {Boolean}
 *
 */
Mapy.LayerTraffic.prototype._viewportTest = function(size, pixel) {
	return (pixel.x >= 0 && pixel.x <= size.x && pixel.y >= 0 && pixel.y <= size.y);
}

/**
 * Nastavi styl do contextu, vraci pouzite styly v objektu.
 *
 * @param {Context} ctx Canvas context
 * @param {Array} pixels Pole s pixely
 * @param {Object} style Styl k aplikovani
 * @param {Boolean} [isOutline] Jedna se o outline caru?
 * @return {Object}
 */
Mapy.LayerTraffic.prototype._setStyleToContext = function(ctx, pixels, style, isOutline) {
	let strokeStyle;
	let globalAlpha = (isOutline ? style.outlineOpacity : style.opacity) || 1;
	let lineWidth = (isOutline ? style.outlineWidth : style.width) || 1;
	let lineDash = (isOutline ? style.outlineDash : style.dash) || [];
	// butt, round, square
	let lineCap = (isOutline ? style.outlineCap : style.cap) || "round";

	if (style.gradient && !isOutline) {
		let gradient = ctx.createLinearGradient(pixels[0].x, pixels[0].y, pixels[pixels.length - 1].x, pixels[pixels.length - 1].y);
		for (let i = 0; i < style.gradient.length; i++) {
			let color = style.gradient[i];
			gradient.addColorStop(i / (style.gradient.length - 1), color);
		}
		strokeStyle = gradient;
	}
	else {
		strokeStyle = (isOutline ? style.outlineColor : style.color) || "#000";
	}

	// pouze zmeny
	if (strokeStyle != ctx.strokeStyle) {
		ctx.strokeStyle = strokeStyle;
	}

	if (globalAlpha != ctx.globalAlpha) {
		ctx.globalAlpha = globalAlpha;
	}

	if (lineWidth != ctx.lineWidth) {
		ctx.lineWidth = lineWidth;
	}

	if (lineCap != ctx.lineCap) {
		ctx.lineCap = lineCap;
	}

	if (lineDash && lineDash != ctx.lineDash) {
		ctx.setLineDash(lineDash);
	}

	return {
		strokeStyle,
		globalAlpha,
		lineWidth,
		lineCap,
		lineDash
	};
};

/**
 * Vykresleni pixelu.
 *
 * @param {Context} ctx Canvas context
 * @param {Array} pixels Pole s pixely
 * @param {Object} ctxStyle Pouzite styly pro context
 */
Mapy.LayerTraffic.prototype._drawPixels = function(ctx, pixels, ctxStyle) {
	ctx.beginPath();

	// cary
	for (let i = 0; i < pixels.length; i++) {
		let pixel = pixels[i];
		ctx.lineTo(pixel.x, pixel.y);
	}

	ctx.stroke();
};
